export default "__VITE_ASSET__BzqwKdvf__"